import { RegisterOptions } from 'react-hook-form'

export const required: RegisterOptions['required'] = {
  value: true,
  message: 'Campo obrigatório'
}
